import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getLanguageBanner, LanguageBanner } from '@services/languageBannerPublicService';
import { getCookie } from '@services/cookieService';
import { CookieKey } from '@models/cookie';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { useAtomValue } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';

export const languageBannerKey = 'languageBanner';

export function useLanguageBanner(): UseQueryResult<LanguageBanner> {
    const hasLanguageSuggetionCookie = !!getCookie(CookieKey.LanguageSuggestionBanner);
    const { fullUrl, notFound } = useStaticValues();
    const encodedUrl = encodeURIComponent(fullUrl.split('?')[0]);
    const selectedLanguage = useAtomValue(selectedLanguageAtom);

    return useQuery({
        queryKey: [languageBannerKey, encodedUrl, selectedLanguage],
        queryFn: () => getLanguageBanner(encodedUrl, selectedLanguage),
        enabled: !hasLanguageSuggetionCookie && !notFound,
    });
}
